import React from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TRICHYEU_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { Button } from '@components';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';
import { useMutation } from 'react-query';

const schema = yup.object().shape({
    codeTrichYeu: yup.string().required(messageError.emptyMessage).max(50, 'Mã trích yếu không được vượt quá 50 ký tự'),
    soQuyenDinh: yup.string().required(messageError.emptyMessage).max(255, 'Số quyết định không được vượt quá 255 ký tự')
});

const TrichYeuAdd = () => {
    const history = useHistory();

    const addFunc = useMutation((value) =>
        Post(TRICHYEU_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.push(URI_INTERNAL.TRICHYEU_PATH);
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới trích yếu</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        codeTrichYeu: '',
                        soQuyenDinh: '',
                        description: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Mã trích yếu',
                                        name: 'codeTrichYeu',
                                        value: values.codeTrichYeu,
                                        onChange: handleChange,
                                        isInvalid: errors.codeTrichYeu,
                                        error: errors.codeTrichYeu
                                    },
                                    {
                                        label: 'Số quyết định',
                                        name: 'soQuyenDinh',
                                        value: values.soQuyenDinh,
                                        onChange: handleChange,
                                        isInvalid: errors.soQuyenDinh,
                                        error: errors.soQuyenDinh
                                    }
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Col sm="10">
                                        <Editor
                                            name="description"
                                            value={values.description}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'description',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={addFunc.isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.TRICHYEU_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                {addFunc.isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default TrichYeuAdd;
